module.exports = __webpack_public_path__ + "static/img/logo.2acc8c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav/logo.png
// module id = INtC
// module chunks = 1